import React from 'react';
import { useRouter } from 'next/router';
import * as S from './Tabs.styled';

interface TabsProps {
  tabs: {
    label: string;
    value: string;
    href?: string;
    active: boolean;
  }[];
  activeTab: string;
  hasPadding?: boolean;
  useHashNavigation?: boolean;
  onTabChange?: (tab: string) => void;
}

export const Tabs = ({
  tabs,
  activeTab,
  onTabChange,
  hasPadding = false,
  useHashNavigation = false,
}: TabsProps) => {
  const router = useRouter();

  const handleTabChange = (tab: string) => {
    onTabChange?.(tab);

    if (useHashNavigation) {
      const isDefaultTab = tab === tabs[0].value;
      const hash = isDefaultTab ? '' : `#${tab}`;

      window.history.replaceState(null, '', `${router.pathname}${hash}`);
    }
  };

  return (
    <S.Tabs $hasPadding={hasPadding}>
      {tabs.map(tab => (
        <S.Tab
          key={tab.value}
          role="tab"
          href={tab.href ?? '#'}
          $isActive={tab.value === activeTab}
          onClick={() => handleTabChange(tab.value)}
        >
          {tab.label}
        </S.Tab>
      ))}
    </S.Tabs>
  );
};
